/** Skritter / Nathan Dummitt tone palette: 1st=red, 2nd=yellow, 3rd=green, 4th=blue, neutral(0)=grey. */
export const SKRITTER_TONE_COLORS = {
  tone0Color: "#9E9E9E",
  tone1Color: "#E53935",
  tone2Color: "#FBC02D",
  tone3Color: "#43A047",
  tone4Color: "#1E88E5",
} as const;
